import React, {useEffect, useState} from 'react';
import {isNotEmpty} from "../../core/core/utils";
import {useDispatch} from "react-redux";
import {CopyRight} from "../index";
import {LostAndFound} from "./LostAndFound";


export const Contact = ({id,handleTabs,checkActive,onSelectItem,page})=>{
  const [selected, setSelected] = useState(null);
  const dispatch = useDispatch();
  useEffect(()=>{
    setSelected(id)
  },[id])
  return  (
    <li id="contacts"  className={`${checkActive('contact')}`} >
      <CopyRight/>
      <div className="item-head" onClick={()=>handleTabs("contact")}><span>Contact</span></div>
      <div className="item-body">
        <div id="terms" className="terms" onClick={() => {
          if (selected === 'terms') {
            handleTabs("contact")
          } else {
            onSelectItem('terms')
          }
        }}>
          Terms & Conditions
        </div>
        {
          (page==='contact' && id==='terms')?
            <div id="terms-box" className="terms-box">
              <div className="white-terms">
                ონლაინ ბილეთის შეძენა შეუძლიათ მხოლოდ რეგისტრირებულ და ვერიფიცირებულ პირებს;
                <br/> ონლაინ ბილეთის ყიდვა შესაძლებელია ვიზა და მასტერქარდის პლასტიკური ბარათებით;
                <br/> ვერიფიცირებულ პირს მხოლოდ ერთი ონლაინ ბილეთის შეძენა შეუძლია;
                <br/> გაყიდული ონლაინ ბილეთი უკან არ ბრუნდება;
                <br/> დაკარგული ნივთის შემთხვევაში შეავსეთ ვებგვერდზე მოცემული ფორმა, გაითვალისწინეთ გარდერობის გარეთ დატოვებულ ნივთებზე ადმინისტრაცია პასუხისმგებლობას არ იღებს.

                <br/> საკლუბო ღამეზე დასასწრებად აუცილებლად უნდა წარმოადგინოთ:
                <br/>&#8226; &nbsp; ონლაინ ბილეთის უნიკალური კოდი.
                <br/>&#8226; &nbsp; პირადობის დამადასტურებელი მოწმობა (მხოლოდ ფიზიკური დოკუმენტი, არ მიიღება ასლი ან ტელეფონში არსებული ფოტო)
{/*
                <br/>&#8226; &nbsp; ვაქცინაციის ან გამოჯანმრთელების EU Digital COVID Certificate.
*/}
                <br/>
                <br/> Online ticket can be purchased for only verified users;
                <br/> Only visa and mastercard credit cards are available to pay for the online ticket;
                <br/> Verified user can purchase a maximum 1 online ticket;
                <br/> Online ticket is non-refundable.
                <br/> For the lost items please fill in the Lost & Found form;
                <br/> We are not responsible for the items which are lost outside the cloakroom.
                <br/> In order to enter the club, you have to present the following:
                <br/>&#8226; &nbsp; Online Ticket QR code.
                <br/>&#8226; &nbsp; It is mandatory to present your ID or Passport with your ticket.  [no scan, no photocopy] ID needs to be valid. Out of date forms of ID will not be accepted. No ID, no entry!
{/*
                <br/>&#8226; &nbsp; Proof of vaccination or Recovery Only with EU Digital COVID Certificate.
*/}


              </div>
              <div className="red-terms">
							<span className="red-terms-title">
								გაეცანით BASSIANI / HOROOM-ის ზოგად წესებს:
								<br/>REMEMBER THAT IT IS STRICTLY FORBIDDEN TO:
							</span>
                <ul className="red-terms-list">
                  <li className="caut-lght">
									<span>
										ტელეფონის ეკრანის და
										<br/>  სანათის გამოყენება.
										<br/> Use telephone screen light or flashlight.
									</span>
                  </li>
                  <li className="caut-weap">
									<span>
										ტერიტორიაზე ცივი იარაღების,
										<br/> ფეთქებადი და აალებადი ნივთების შეტანა.
										<br/> Bringing flammable/explosive materials.
									</span>
                  </li>
                  <li className="caut-pic">
									<span>
										ფოტო და ვიდეო გადაღება.
										<br/> Please respect our no photo / Video policy.
									</span>
                  </li>
                  <li className="caut-tick">
									<span>
										ონლაინ ბილეთის სხვისთვის გადაცემა.
										<br/> Giving out tickets to another person.
									</span>
                  </li>
                  <li className="caut-age">
									<span>
										18 წლამდე პირების დაშვება.
										<br/> Entrance of persons under 18.
									</span>
                  </li>
                  <li className="caut-smk">
									<span>
										კლუბის შიდა ტერიტორიაზე თამბაქოს მოხმარება.
										<br/> Smoking is prohibited inside the club.
									</span>
                  </li>
                </ul>
              </div>
            </div>:
            <div className="contact-box">
              <section className="left-side-sec">
                <div className="left-side-title">
                  lost and found
                </div>
                <LostAndFound/>
                <div className="lost-condition">
								<span>
									Lost Items Won't Be Stored Longer Than 2 Months.<br/>
									Working Hours: Monday-Friday, 2 P.M - 8 P.M<br/>

								</span>
                  <span style={{cursor:"pointer"}} onClick={()=>dispatch({type:'POPUP_WINDOW',payload:true,modal: "copyright"})}>
									© 2021 bassiani
								</span>
                </div>
              </section>
              <section className="right-side-sec">
                <div className="right-side-title">
                  <p>
                    <span>2, Akaki Tsereteli Ave., 1234 Tbilisi</span>
                    <span>info@bassiani.com</span>
                  </p>
                </div>
                <div className="right-side-img">

                  <iframe className="bassiani-map" style={{filter: "invert(1) hue-rotate(269deg) grayscale(1) brightness(1.5)"}} width="100%" height="100%" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=100%25&amp;height=100%25&amp;hl=en&amp;q=Boris%20Paichadze%20Dinamo%20Arena+(My%20Business%20Name)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"/>
                </div>
              </section>
            </div>
        }
      </div>
    </li>
  )
}
